import { Component, Inject, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppSetting, AppSettingHistoryEntry } from '../../_models/admin/app-setting.models';
import { AppSettingsService } from '../../_services/app-settings/app-settings.service';
import { SETTING_BRANDS } from './app-settings.constants';
import { AdminEmailComponent } from '../../shared/admin-ux/admin-email.component';

export interface AppSettingHistoryData {
  setting: AppSetting;
}

/** The change history of one setting and its brand overrides (latest 50, newest first), as a right-hand drawer. */
@Component({
  selector: 'app-setting-history-drawer',
  standalone: true,
  imports: [DatePipe, AdminEmailComponent],
  templateUrl: 'app-setting-history-drawer.component.html'
})
export class AppSettingHistoryDrawerComponent implements OnInit {

  public rows: AppSettingHistoryEntry[] = [];
  public loading = false;
  public error: string = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AppSettingHistoryData,
    private dialogRef: MatDialogRef<AppSettingHistoryDrawerComponent>,
    private service: AppSettingsService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.service.getHistory(this.data.setting.settingKey).subscribe({
      next: rows => {
        this.loading = false;
        this.rows = rows || [];
      },
      error: error => {
        this.loading = false;
        this.error = (error && error.message) || 'Could not load the history.';
      }
    });
  }

  public describe(value: string | null): string {
    if (value === null || value === undefined) {
      return 'not set';
    }
    if (value === '') {
      return 'blank';
    }
    if ((this.data.setting.valueType || '').toLowerCase() === 'bool') {
      return value === 'true' ? 'On' : 'Off';
    }
    return value;
  }

  /** The brand a per-brand change applied to. */
  public brandName(companyId: number): string {
    return (SETTING_BRANDS.find(b => b.companyId === companyId) || { name: 'Brand ' + companyId }).name;
  }

  public close(): void {
    this.dialogRef.close();
  }
}
